//Makes Color Box Responsive
var cboxOptions = {
  width: '95%',
  height: '95%',
  maxWidth: '800px',
  maxHeight: '800px'
};

$('.cbox-link').colorbox(cboxOptions);

$(window).resize(function() {
  if (
    !$('#colorbox').hasClass('variantSelectMobile') &&
    !$('#colorbox').hasClass('coexistence-overlay') &&
    !$('#colorbox').hasClass('chase-overlay') &&
    !$('#colorbox').hasClass('coexistence-cart-overlay-class') &&
    !$('#colorbox').hasClass('email-notification-overlay-main') &&
    !$('#colorbox').hasClass('exp-email-notification-overlay-main')&&
    !$('#colorbox').hasClass('mfa-session-timeout-overlay-popup') &&
    !$('#colorbox').hasClass('rgh-for-Existing-Account-modal')
  ) {
    $.colorbox.resize({
      width:
        window.innerWidth > parseInt(cboxOptions.maxWidth)
          ? cboxOptions.maxWidth
          : cboxOptions.width,
      height:
        window.innerHeight > parseInt(cboxOptions.maxHeight)
          ? cboxOptions.maxHeight
          : cboxOptions.height
    });
  }
});

ACC.colorbox = {
  config: {
    maxWidth: '100%',
    opacity: 0.7,
    width: 'auto',
    transition: 'none',
    close:
      '<span class="sr-only">Close button</span><span class="svg-icon_close svg-icon_close-dims close-icon-size-overlay" role="button" aria-label="close Icon"></span>',
    title: '',
    onComplete: function() {
      $.colorbox.resize();
      ACC.common.refreshScreenReaderBuffer();
    },
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }
  },

  open: function(title, config) {
    var config = $.extend({}, ACC.colorbox.config, config);
    config.title = config.title.replace(/{title}/g, title);
    setTimeout(function() {
      $('#colorbox').focus();
    }, 200);
    return $.colorbox(config);
  },

  resize: function() {
    $.colorbox.resize();
  },

  close: function() {
    $.colorbox.close();
  }
};
